/**
 * Pick up external links in the main website content and add a class to them
 */
const ExternalLinks = () => {
    const markExternalLinks = () => {
        const links = document.querySelectorAll('.main .page a:not(.external)');

        links.forEach(link => {
            const href = link.getAttribute('href');

            if (!href) {
                return;
            }

            // ignore on btns
            if (link.classList.contains('btn')) {
                return;
            }

            if (href.startsWith('https://') || href.startsWith('http://')) {
                if (href.indexOf(window.location.origin) > -1) {
                    // absolute to same website.
                    return;
                }

                if (
                    href.indexOf('s3.ap-southeast-2.amazonaws.com/public') > -1
                ) {
                    // asset path
                    return;
                }

                link.classList.add('external');
            }
        });
    };

    markExternalLinks();

    document.addEventListener('pjax:complete', () => {
        markExternalLinks();
    });
};

export default ExternalLinks;
